import { useState } from 'react';
const Subjects = ({subjectsList, setSubjectsList}) => {
  const [subjectName, setSubjectName] = useState('');
  const [certification, setCertification] = useState('No');


  const handleAddSubject = () => {
    const trimmedName = subjectName.trim();
    if (!trimmedName) return;

    setSubjectsList([
      ...subjectsList,
      { name: trimmedName, certification }
    ]);

    setSubjectName('');
    setCertification('No');
  };

  const handleDeleteSubject = (name) => {
    setSubjectsList(subjectsList.filter((item) => item.name !== name));
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') handleAddSubject();
  };

  return (
  <div className="max-w-4xl mx-auto p-6 space-y-6">
  {/* Row 1: Subject Name */}
  <div>
    <div className="flex items-center gap-2 mb-3">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <label className="text-sm font-semibold text-gray-700">Subject Name</label>
    </div>
    <input
      type="text"
      placeholder="Enter Subject Name"
      value={subjectName}
      onChange={(e) => setSubjectName(e.target.value)}
      onKeyPress={handleKeyPress}
      className="w-full px-4 py-3 bg-gray-50 border border-gray-300 rounded-xl text-gray-900 placeholder:text-gray-400 focus:outline-none focus:border-[#0f6abf] focus:ring-2 focus:ring-[#0f6abf]/20 transition-all"
    />
  </div>

  {/* Row 2: Certification */}
  <div>
    <div className="flex items-center gap-2 mb-3">
      <div className="w-1.5 h-4 bg-[#0f6abf] rounded-full"></div>
      <label className="text-sm font-semibold text-gray-700">Certification</label>
    </div>
    <div className="flex gap-6">
      <label className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer">
        <div className="relative">
          <input
            type="radio"
            name="certification"
            value="Yes"
            checked={certification === 'Yes'}
            onChange={() => setCertification('Yes')}
            className="sr-only"
          />
          <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${certification === 'Yes' ? 'border-[#0f6abf]' : 'border-gray-300'}`}>
            {certification === 'Yes' && <div className="w-2.5 h-2.5 bg-[#0f6abf] rounded-full"></div>}
          </div>
        </div>
        <span>Yes</span>
      </label>
      <label className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer">
        <div className="relative">
          <input
            type="radio"
            name="certification"
            value="No"
            checked={certification === 'No'}
            onChange={() => setCertification('No')}
            className="sr-only"
          />
          <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${certification === 'No' ? 'border-[#0f6abf]' : 'border-gray-300'}`}>
            {certification === 'No' && <div className="w-2.5 h-2.5 bg-[#0f6abf] rounded-full"></div>}
          </div>
        </div>
        <span>No</span>
      </label>
    </div>
  </div>

  {/* Row 3: Add Button */}
  <div>
    <button
      className="px-6 py-3 bg-[#0f6abf] text-white font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors flex items-center gap-2"
      onClick={handleAddSubject}
    >
      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
      </svg>
      Add Subject
    </button>
  </div>

  {/* Added Subjects List */}
  {subjectsList.length > 0 ? (
    <div className="space-y-3 pt-4 border-t border-gray-200">
      {subjectsList.map((item, index) => (
        <div
          key={index}
          className="flex items-center justify-between bg-white p-4 border border-gray-200 rounded-xl hover:border-gray-300 transition-colors"
        >
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
              <svg className="w-4 h-4 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
              </svg>
            </div>
            <span className="text-sm font-medium text-gray-900">{item.name}</span>
            <span
              className={`text-xs px-2.5 py-1 rounded-lg font-medium ${
                item.certification === 'Yes' 
                  ? 'bg-green-100 text-green-700' 
                  : 'bg-gray-100 text-gray-700'
              }`}
            >
              {item.certification}
            </span>
          </div>
          <button
            onClick={() => handleDeleteSubject(item.name)}
            className="p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors"
          >
            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
            </svg>
          </button>
        </div>
      ))}
    </div>
  ) : (
    <div className="border-2 border-dashed border-gray-300 rounded-2xl p-8 text-center">
      <div className="w-16 h-16 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-4">
        <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
        </svg>
      </div>
      <h3 className="text-lg font-medium text-gray-700 mb-2">No subjects added yet</h3>
      <p className="text-sm text-gray-500">Add your first subject above</p>
    </div>
  )}
</div>

  );
};

export default Subjects;
